export default "__VITE_ASSET__8aac22ba__"